import { render } from "./confirmPayDiy.vue?vue&type=template&id=6980e380&lang=true"
import script from "./confirmPayDiy.vue?vue&type=script&lang=js"
export * from "./confirmPayDiy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__